import React, { useContext } from 'react';
import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { SettingsContext } from '../context';

export default function() {
  const { language } = useContext(SettingsContext);
  return (
    <Typography variant="body1">
      <Trans i18nKey="errorLoginAccess">
        In accordance to our new
        <a href={`/auth/${language || 'en'}/privacy`}>Privacy Policy</a> and
        <a href={`/auth/${language || 'en'}/agreement`}>User Agreement</a> your
        email will be used as your login. You are kindly asked to login using
        your email.
      </Trans>
    </Typography>
  );
}
